import { createContext } from 'react';
import { Contracts as PeripheryContracts } from '@airdao/bond-periphery';

const BondPeripheryContext = createContext<PeripheryContracts | null>(null);

export default BondPeripheryContext;
